module.exports = "<p>\n  reports works!\n</p>\n"